import React from 'react'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import "./desktopnavpopup.css"
import {updatePassword} from "./actions";

class ChangePasswordPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPassword: '',
            newPassword: '',
            confirmNewPassword: '',
            confirmNewPasswordType: 'search',
            currentPasswordType: 'search',
            passwordType: 'search'
        };
    }

    handleInputChange = (e) => {
        const {placeholderInputTypeAction} = this;

        this.setState({
            [e.target.name]: e.target.value
        });

        placeholderInputTypeAction(e.target.name, e);
    };

    backToMain = (success) => {
        const {back} = this.props;

        setTimeout(() => {
            back('Home');
        }, 3000);
        return success
    };

    placeholderInputTypeAction = (field, e) => {
        let value = e.target.value;
        let fieldName = field + 'Type';

        value === '' ?
            this.setState({
                [fieldName]: 'search'
            })
            :
            this.setState({
                [fieldName]: 'password'
            });
    };

    render() {
        const {back, updatePassword, passwordUpdateMessage, messageColor, formErrors} = this.props;
        const {backToMain} = this;

        return (
            <div>
                <div onClick={() => back('Home')}>
                    <img className="back-arrow" src={`${process.env.PUBLIC_URL}/arrow_back.png`} alt=""/>
                </div>
                <div className="panel-form-input-container">
                    {/*<div>Change Password</div>*/}
                    <div className="form-space">
                    </div>
                    <input
                        type={this.state.currentPasswordType}
                        name="currentPassword"
                        placeholder="Current Password"
                        value={this.state.currentPassword}
                        onChange={this.handleInputChange}
                    />
                    <div className="password-error-wrapper">
                        {formErrors.password}
                    </div>
                    <div className="extra-form-space">
                    </div>
                    <input
                        type={this.state.newPasswordType}
                        placeholder="New Password"
                        name="newPassword"
                        value={this.state.newPassword}
                        onChange={this.handleInputChange}
                    />
                    <div className="form-space">
                    </div>
                    <input
                        type={this.state.confirmNewPasswordType}
                        name="confirmNewPassword"
                        placeholder="Confirm Password"
                        value={this.state.confirmNewPassword}
                        onChange={this.handleInputChange}
                    />
                </div>
                <div className="button-container-center">
                    <div
                        className="navpop-up-blue-btn"
                        onClick={() => updatePassword({
                            email: this.props.email,
                            currentPassword: this.state.currentPassword,
                            newPassword: this.state.newPassword,
                            confirmNewPassword: this.state.confirmNewPassword
                        })}
                    >
                        Change Password
                    </div>
                </div>
                <div
                    className="password-change-message"
                    style={{color: messageColor}}>
                    {passwordUpdateMessage === 'Password Successfully Updated' ? backToMain(passwordUpdateMessage) : ''}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, {match: {params}}) => {
    return {
        email: state.loginReducer.authentication.email,
        passwordUpdateMessage: state.desktopNavReducer.passwordUpdateMessage,
        messageColor: state.desktopNavReducer.messageColor,
        formErrors: state.desktopNavReducer.formErrors,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        updatePassword: payload => {
            dispatch(updatePassword(payload))
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ChangePasswordPanel))